<script>
    import { buyGems } from "commerce/stores/buyGems";

    import { isAppFeatureEnabled } from "commerce/lib/account-details";

    import { notMouseEvent }  from "lib/mouse-events";
    import { getTooltipText } from "lib/text-tooltip";

    import css from "../quotes.css";

    import { game } from "native";

    const i18n = window.strings;

    const disabled = !isAppFeatureEnabled("billing");

    // Simulate mouseenter/mouseleave, chromium 28 doesn't support these events yet

    function textTooltip(text, e) {
        if (notMouseEvent(e)) {
            if (e.target.getAttribute("hide-tooltip")) {
                return game.call("HideTextTooltip");
            }

            if (!e.relatedTarget.getAttribute("hide-tooltip")) {
                return;
            }
        }

        if (!text) {
            game.call("HideTextTooltip");

            return;
        }

        game.call("ShowTextTooltip", text);
    }

    function showBilling() {
        if (disabled) {
            return;
        }

        // this opens the Gem purchase in the Gemstore
        if (window.native.stats.provider === "Steam") {
            return GW2.config.features["billing-steam"] ? window.native.call("BuyGems") : null;
        }

        buyGems.set(true);
    }

    // TODO: css.disabled
</script>

<div
    class="{`hbox ${css.offerButton}`}"
    data-disabled={disabled}
    on:click={showBilling}
    on:mouseover={textTooltip.bind(null, disabled ? getTooltipText({ type : "billing" }) : null)}
    on:mouseout={textTooltip.bind(null, null)}
>
    <button class="{css.btn}" disabled={disabled}>
        {i18n.exchange.gold2gems.buyMoreGems}
    </button>
</div>